<template>
	<div class="clauseBox">
		<p>{{ $t('footer.company') }} 이용자 약관
		</p><p>발효일자: 2025년 6월 3일
		</p><p>개발자: {{ $t('footer.company') }}
		</p><p>
		</p><p>본 애플리케이션을 사용하시기 전에 본 약관을 주의 깊게 읽어주시기 바랍니다. "동의" 버튼을 클릭하거나 애플리케이션을 사용함으로써 귀하는 본 약관의 모든 조항에 동의하게 됩니다.
		</p><p>
		</p><p>제1조 계정 관리
		</p><p>1.1 계정 등록
		</p><p>
		</p><p>Google/Facebook 계정으로 빠른 로그인 가능
		</p><p>
		</p><p>소셜 계정으로 로그인 시, 귀하의 공개 정보(이름, 이메일, 프로필 사진)에 대한 접근을 허용한 것으로 간주됩니다
		</p><p>
		</p><p>1.2 계정 보안
		</p><p>
		</p><p>귀하는 계정 비밀번호 및 기기 접근 권한을 안전하게 관리할 책임이 있습니다
		</p><p>
		</p><p>이상 로그인 발생 시 즉시 ylqyd369@gmail.com 으로 연락주시기 바랍니다
		</p><p>
		</p><p>1.3 계정 종료
		</p><p>
		</p><p>12개월 연속 로그인하지 않을 경우 계정이 휴면 상태로 전환됩니다
		</p><p>
		</p><p>설정 메뉴를 통해 언제든지 계정 탈퇴 가능 (탈퇴는 72시간 이내에 처리됩니다)
		</p><p>
		</p><p>제2조 사용자 콘텐츠 정책
		</p><p>2.1 콘텐츠 사용 허가
		</p><p>귀하가 이미지/영상/음성 등 콘텐츠를 업로드하는 경우:
		</p><p>
		</p><p>당사에 전 세계적이며 비독점적인 사용 권한을 부여한 것으로 간주됩니다
		</p><p>
		</p><p>권한 기간: 업로드일로부터 계정 탈퇴 후 90일까지
		</p><p>
		</p><p>사용 범위: 저장, 표시, 기술적 처리 등 필수적인 운영 목적
		</p><p>
		</p><p>2.2 금지된 콘텐츠
		</p><p>다음과 같은 콘텐츠는 업로드 또는 공유할 수 없습니다:
		</p><p>
		</p><p>타인의 지식재산권을 침해하는 콘텐츠
		</p><p>
		</p><p>폭력, 혐오, 음란 등 불법 콘텐츠
		</p><p>
		</p><p>바이러스/악성코드 등 시스템을 위협하는 콘텐츠
		</p><p>
		</p><p>허위 또는 오해의 소지가 있는 정보
		</p><p>
		</p><p>2.3 콘텐츠 검토 권한
		</p><p>당사는 다음 권한을 보유합니다:
		</p><p>
		</p><p>약관 위반 콘텐츠의 삭제
		</p><p>
		</p><p>위반 계정의 일시 정지 또는 종료
		</p><p>
		</p><p>법 집행 기관에 필요한 정보를 제공
		</p><p>
		</p><p>제3조 광고 서비스 약관
		</p><p>3.1 광고 표시
		</p><p>
		</p><p>본 애플리케이션은 Google AdMob, Facebook Audience 등 제3자 플랫폼을 통해 광고를 표시합니다
		</p><p>
		</p><p>광고 내용은 제3자 제공으로 당사가 완전하게 통제하지 않습니다
		</p><p>
		</p><p>3.2 광고 상호작용
		</p><p>
		</p><p>광고 클릭 시 외부 웹사이트로 이동할 수 있습니다
		</p><p>
		</p><p>제3자 웹사이트의 행위는 본 약관에 포함되지 않습니다
		</p><p>
		</p><p>광고 관련 거래의 책임은 사용자에게 있습니다
		</p><p>
		</p><p>3.3 맞춤형 광고
		</p><p>
		</p><p>기본적으로 관심사 기반의 맞춤형 광고가 제공됩니다
		</p><p>
		</p><p>Android 설정을 통해 비활성화할 수 있습니다:
		</p><p>설정 → Google → 광고 → 맞춤형 광고 선택 해제
		</p><p>
		</p><p>제4조 지식재산권
		</p><p>4.1 애플리케이션 권리
		</p><p>당사는 다음에 대한 모든 권리를 보유합니다:
		</p><p>
		</p><p>애플리케이션 소스코드, UI 디자인, 상표
		</p><p>
		</p><p>문서, 데이터베이스, 알고리즘 등 핵심 기술
		</p><p>
		</p><p>광고 표시 및 분석 시스템
		</p><p>
		</p><p>4.2 사용자 권리
		</p><p>귀하는 자작 콘텐츠에 대한 모든 권리를 보유하지만, 다음에 동의합니다:
		</p><p>
		</p><p>당사가 앱 내에 귀하의 콘텐츠를 표시할 수 있도록 허용
		</p><p>
		</p><p>다른 사용자가 귀하의 공개 콘텐츠를 조회/공유할 수 있도록 허용
		</p><p>
		</p><p>제5조 면책 조항
		</p><p></p><p>5.1 서비스 가용성
		</p><p>
		</p><p>애플리케이션은 "있는 그대로" 제공되며, 영구적인 사용 가능성을 보장하지 않습니다
		</p><p>
		</p><p>유지보수 또는 업그레이드로 인해 일시적으로 중단될 수 있습니다
		</p><p>
		</p><p>5.2 콘텐츠 정확성
		</p><p>
		</p><p>사용자 생성 콘텐츠의 정확성을 보장하지 않습니다
		</p><p>
		</p><p>제3자 링크의 보안 또는 내용에 대해 책임지지 않습니다
		</p><p>
		</p><p>5.3 기능 제한
		</p><p>
		</p><p>전화 권한은 단지 수신 전화 상태 확인 용도로만 사용되며, 통화 내용은 모니터링하지 않습니다
		</p><p>
		</p><p>녹음/카메라 기능은 사용자의 명시적인 동작 없이는 활성화되지 않습니다
		</p><p>
		</p><p>5.4 제3자 책임
		</p><p>다음과 같은 경우 당사는 책임지지 않습니다:
		</p><p>
		</p><p>광고주로 인한 손해
		</p><p>
		</p><p>소셜 로그인 서비스 중단
		</p><p>
		</p><p>장치 호환성 문제로 인한 기능 오류
		</p><p>
		</p><p>제6조 유료 서비스 (해당되는 경우)
		</p><p>6.1 인앱 구매
		</p><p>
		</p><p>인앱 결제는 Google Play 결제 시스템을 통해 처리됩니다
		</p><p>
		</p><p>모든 판매는 최종 거래이며, 환불되지 않습니다
		</p><p>
		</p><p>6.2 구독 서비스
		</p><p>
		</p><p>자동 갱신 구독은 갱신 주기에 대해 명확히 안내됩니다
		</p><p>
		</p><p>해지 경로: Google Play → 구독 관리
		</p><p>
		</p><p>제7조 약관 변경
		</p><p>7.1 업데이트 공지
		</p><p>
		</p><p>중요한 변경사항은 앱 내에 7일간 공지됩니다
		</p><p>
		</p><p>이전 약관 버전 보관소: https://terms.yourdomain.com/archive
		</p><p>
		</p><p>7.2 사용 지속 시 동의 간주
		</p><p>
		</p><p>약관 변경 후에도 계속해서 애플리케이션을 사용할 경우, 변경된 약관에 동의한 것으로 간주됩니다
		</p><p>
		</p><p>최신 업데이트일은 약관 상단에 명시됩니다
		</p><p>
		</p><p>제8조 법률 및 관할
		</p><p>8.1 준거법
		</p><p>
		</p><p>본 약관은 귀하가 거주하는 국가/지역의 법률을 따릅니다
		</p><p>
		</p><p>법률 간 충돌 원칙은 배제됩니다
		</p><p>
		</p><p>8.2 분쟁 해결
		</p><p>분쟁은 우선적으로 협상을 통해 해결하며, 협상이 실패할 경우:
		</p><p>
		</p><p>[중재 기관명]에 중재 신청
		</p><p>
		</p><p>중재 장소: [도시명], 중재 언어: [사용 언어]
		</p><p>
		</p><p>제9조 연락처
		</p><p>운영 관련 문의: {{ $t('footer.email') }}
		</p><p>저작권 침해 신고: {{ $t('footer.email') }}
		</p><p>법률 관련 문의: {{ $t('footer.email') }}
		</p><p>
		</p><p>응답 시간:
		</p><p>
		</p><p>일반 문의: 48시간 이내
		</p><p>
		</p><p>침해 신고: 24시간 이내 1차 응답
		</p><p>
		</p><p>제10조 전체 계약
		</p><p>본 약관은 개인정보 처리방침(https://yourdomain.com/privacy)과 함께 전체적인 법적 문서를 구성합니다.
		</p><p>약관의 일부 조항이 무효가 되더라도, 나머지 조항의 유효성에는 영향을 미치지 않습니다.
		</p>
	</div>
</template>

<script>
</script>

<style>
</style>